// extracted by mini-css-extract-plugin
export default {"cred_label":"add-aws-firewall_cred_label__NEFBh"};